import api from 'api/axiosInstance';
import type { Currency, RedirectionParams } from 'types/global.types';
import type { StandingOrderFrequency } from 'types/transactions.types';
import type {
  TransferReasons,
  TransferTypes,
} from 'components/pages/Banks/Wallet/MoneyTransfer/types';

export type MakeTransferBody = RedirectionParams & {
  fromConnectorId: string;
  toConnectorId?: string;
  communication?: {
    message: string;
    type: 'structured' | 'unstructured';
  };
  beneficiary?: {
    iban: string;
    name: string;
    // token obligatory for external transfers but backward compatible yet
    verificationToken?: string;
  };
  amount?: {
    value: number;
    currency: Currency;
  };
  reason?: TransferReasons;
  type: TransferTypes;
  // Standing order properties
  period?: StandingOrderFrequency;
  firstExecutionDate?: string;
  lastExecutionDate?: string;
  requestedExecutionAt?: string;
};

type MakeTransferResponse = {
  redirectUri: string;
  _id: string;
  status: string;
  type: string;
  amount: {
    value: number;
    currency: Currency;
  };
  reason: TransferReasons;
  similarTransactionId: string;
};

const makeTransfer = (body: MakeTransferBody): Promise<MakeTransferResponse> =>
  api.post('/v2/accountable-banking/consent-transfers/start-flow', body);

export default makeTransfer;
